import { COLORS } from '../../../utils/colors'

export const useRoundedInputStyles = () => {
  return {
    roundedInput: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
        backgroundColor: 'white',
        fontSize: '16px',
        lineHeight: '17px',
        fontWeight: '500',
        fontFamily: ['Montserrat', 'sans-serif'].join(','),
        color: COLORS.DARK_GREY,
        '& fieldset': {
          borderRadius: '25px',
        },
        '&:hover fieldset': {
          borderColor: COLORS.DARK_GREY,
        },
        '&.Mui-focused fieldset': {
          borderColor: COLORS.DARK_GREY,
        },
        '&.Mui-error fieldset': {
          borderColor: COLORS.DARK_GREY,
        },
      },
      '& .MuiInputLabel-root': {
        fontWeight: '500',
        lineHeight: '22px',
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: COLORS.DARK_GREY,
      },
      '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
        transform: 'translate(14px, 25%) scale(1)',
      },
    },
  }
}
